(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/hooks/use-charity-payout.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/hooks/use-charity-payout.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect;
const _jotai = jotai,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const selectedResultAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.selectedResultAtom;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_charity_payout.jotai.atoms,
  charityPayoutsAtom = _svs$lyckoplatsen$sha.charityPayoutsAtom,
  charityPayoutChartAtom = _svs$lyckoplatsen$sha.charityPayoutChartAtom;
const fetchCharityPayouts = svs.lyckoplatsen.components.shared_charity.api_calls.fetchCharityPayouts;
const PAYOUT_KEYS = svs.lyckoplatsen.components.shared_constants.CONSTANTS.PAYOUT_KEYS;
const logger = svs.lyckoplatsen.logger;
const useCharityPayout = () => {
  const _useAtom = useAtom(charityPayoutsAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    charityPayouts = _useAtom2[0],
    setCharityPayouts = _useAtom2[1];
  const setPayoutChartData = useSetAtom(charityPayoutChartAtom);
  const selectedResult = useAtomValue(selectedResultAtom);
  const selectedDrawNumber = selectedResult === null || selectedResult === void 0 ? void 0 : selectedResult.drawNumber;
  const handler = async () => {
    var _charityPayouts$PAYOU;
    if (selectedDrawNumber === charityPayouts.latestDraw.drawId) {
      setPayoutChartData(charityPayouts.latestDraw.data);
      return handler;
    }
    if ((_charityPayouts$PAYOU = charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]) !== null && _charityPayouts$PAYOU !== void 0 && _charityPayouts$PAYOU[selectedDrawNumber]) {
      var _charityPayouts$PAYOU2;
      setPayoutChartData((_charityPayouts$PAYOU2 = charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]) === null || _charityPayouts$PAYOU2 === void 0 ? void 0 : _charityPayouts$PAYOU2[selectedDrawNumber]);
      return handler;
    }
    try {
      const fetchedDates = await fetchCharityPayouts(null, selectedDrawNumber);
      const data = fetchedDates.response.payoutStatistics[PAYOUT_KEYS.SPECIFIC_DRAWS][0].data;
      const newObject = _objectSpread(_objectSpread({}, charityPayouts), {}, {
        [PAYOUT_KEYS.SPECIFIC_DRAWS]: _objectSpread(_objectSpread({}, charityPayouts[PAYOUT_KEYS.SPECIFIC_DRAWS]), {}, {
          [selectedDrawNumber]: data
        })
      });
      setPayoutChartData(data);
      setCharityPayouts(newObject);
    } catch (error) {
      logger.error('Failed to fetch charity payouts', error);
      setPayoutChartData(null);
    }
  };
  useEffect(() => {
    handler();
  }, [selectedResult]);
};
setGlobal('svs.lyckoplatsen.components.shared_charity_payout.react.hooks', {
  useCharityPayout
});

 })(window);